import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import DynamicImage from 'components/DynamicImage'
import { TextLH } from 'styles/components/typography'

import {
  Wrapper,
  Box,
  IconWrapper,
  IconStyled,
  Line,
  Info,
  Descriptions,
} from '../../styles'

import { Item, LineWrapper } from './styles'

const DHowOrderRussianBox = ({ data, path }) => (
  <Wrapper>
    <Box>
      <DynamicImage
        image={`${path}/dna-opened-new`}
        imageType="png"
        imageSizes={{ md: 670, lg: 840 }}
        fitOption="contain"
        alt={'Генетический тест'}
      />
    </Box>
    <Descriptions>
      <Info>
        <IconWrapper className="pr-15">
          <IconStyled id="color_locker" />
        </IconWrapper>
        <TextLH dangerouslySetInnerHTML={{ __html: data.info }} />
      </Info>
      {data.opened.list.map(
        (desc, index) =>
          desc && (
            <Fragment key={index}>
              <LineWrapper className={`item-${index} line-${index} pr-15`}>
                <Line />
              </LineWrapper>
              <Item className={`item-${index}`}>
                <TextLH
                  className="text--muted"
                  dangerouslySetInnerHTML={{ __html: desc }}
                />
              </Item>
            </Fragment>
          ),
      )}
    </Descriptions>
  </Wrapper>
)

DHowOrderRussianBox.propTypes = {
  data: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
}

export default DHowOrderRussianBox
